(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["KidsCraft-Rubellos-Section"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('kidscraft-scratch-card')) return;

  class KidsCraftScratchCard extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._paths = this._paths || [];
      this._abort = new AbortController();
      const tryStart = () => {
        if (!this.isConnected || this._started || document.readyState === 'loading') return;
        if (this._start()) {
          this._waiting?.disconnect();
          this._waiting = null;
        }
      };

      this._waiting = new MutationObserver(tryStart);
      this._waiting.observe(this, { childList: true, subtree: true });
      document.addEventListener('DOMContentLoaded', tryStart, { once: true, signal: this._abort.signal });
      queueMicrotask(tryStart);
      this._startFrame = requestAnimationFrame(tryStart);
    }

    disconnectedCallback() {
      this._connected = false;
      this._started = false;
      this._abort?.abort();
      this._waiting?.disconnect();
      this._resizeObserver?.disconnect();
      cancelAnimationFrame(this._startFrame);
      cancelAnimationFrame(this._resizeFrame);
      cancelAnimationFrame(this._checkFrame);
      this._checkFrame = null;
      clearInterval(this._countdownInterval);
      clearTimeout(this._attentionTimeout);
      this.classList.remove('is-attention');
      this._finishPointer(false);
    }

    _start() {
      this._canvas = this.querySelector('[data-scratch-canvas]');
      this._surface = this.querySelector('.kc-scratch__surface');
      this._reward = this.querySelector('[data-scratch-reward]');
      if (!this._canvas || !this._surface || !this._reward) return false;
      this._started = true;
      this._threshold = this._number(this.dataset.threshold, 45, 1, 100);
      this._brush = this._number(this.dataset.brush, 34, 8, 100);
      this._label = this.querySelector('[data-scratch-cover-label]');
      this._buttons = Array.from(this.querySelectorAll('[data-reveal-trigger]'));
      this._links = Array.from(this.querySelectorAll('[data-offer-link]'));
      this._revealOnly = Array.from(this.querySelectorAll('[data-reveal-only]'));
      this._statuses = Array.from(this.querySelectorAll('[data-scratch-status]'));
      const options = { signal: this._abort.signal };
      this._buttons.forEach(button => {
        button.addEventListener('click', event => {
          event.preventDefault();
          if (button.dataset.scratchAction === 'highlight') this._highlight();
          else this._reveal();
        }, options);
      });
      this._canvas.style.touchAction = 'none';
      this._canvas.addEventListener('pointerdown', event => this._pointerDown(event), options);
      this._canvas.addEventListener('pointermove', event => this._pointerMove(event), options);
      this._canvas.addEventListener('pointerup', event => this._pointerEnd(event), options);
      this._canvas.addEventListener('pointercancel', event => this._pointerEnd(event), options);
      this._canvas.addEventListener('lostpointercapture', event => this._pointerEnd(event), options);

      if (this._revealed || this._wasRemembered()) {
        this._revealed = true;
        this._setState('revealed');
        return true;
      }

      this._startCountdown();
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden && !this._revealed) this._updateCountdown();
      }, options);

      try {
        this._context = this._canvas.getContext('2d', { willReadFrequently: true });
        if (!this._context) throw new Error('Canvas unavailable');
        this._setState(this._paths.length ? 'scratching' : 'locked');
        this._resize();
        const resize = () => {
          cancelAnimationFrame(this._resizeFrame);
          this._resizeFrame = requestAnimationFrame(() => this._resize());
        };
        if (typeof ResizeObserver !== 'undefined') {
          this._resizeObserver = new ResizeObserver(resize);
          this._resizeObserver.observe(this._surface);
        }
        window.addEventListener('resize', resize, options);
      } catch (_error) {

        this._reveal();
      }
      return true;
    }

    _number(value, fallback, min, max) {
      const parsed = Number.parseFloat(value);
      return Number.isFinite(parsed) ? Math.min(max, Math.max(min, parsed)) : fallback;
    }

    _startCountdown() {
      clearInterval(this._countdownInterval);
      const date = (this.dataset.countdownEnd || '').trim();
      // Require an explicit time zone so every visitor has the same deadline.
      this._deadline = /(?:Z|[+-]\d{2}:\d{2})$/.test(date) ? Date.parse(date) : NaN;
      if (this._updateCountdown()) {
        this._countdownInterval = setInterval(() => this._updateCountdown(), 1000);
      }
    }

    _updateCountdown() {
      const time = this.querySelector('[data-countdown-time]');
      const label = this.querySelector('[data-countdown-label]');
      if (!time || !label) return false;
      if (!Number.isFinite(this._deadline)) {
        label.textContent = this.dataset.countdownFallback || '';
        time.hidden = true;
        clearInterval(this._countdownInterval);
        return false;
      }
      time.hidden = false;
      const remaining = Math.max(0, Math.ceil((this._deadline - Date.now()) / 1000));
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      time.textContent = [hours, minutes, seconds].map(value => String(value).padStart(2, '0')).join(':');
      label.textContent = remaining ? this.dataset.countdownLabel : this.dataset.countdownExpired;
      this.dataset.expired = String(remaining === 0);
      if (!remaining) clearInterval(this._countdownInterval);
      return remaining > 0;
    }

    _highlight() {
      if (this._revealed) return;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const rect = this._surface.getBoundingClientRect();
      if (window.matchMedia('(max-width: 749px)').matches || rect.top < 0 || rect.bottom > window.innerHeight) {
        this._surface.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'center', inline: 'nearest' });
      }
      clearTimeout(this._attentionTimeout);
      this.classList.remove('is-attention');
      void this._surface.offsetWidth;
      this.classList.add('is-attention');
      this._attentionTimeout = setTimeout(() => this.classList.remove('is-attention'), 2400);
    }

    _resize() {
      if (!this.isConnected || this._revealed || !this._context) return;
      const rect = this._surface.getBoundingClientRect();
      const width = Math.round(rect.width);
      const height = Math.round(rect.height);
      if (width < 1 || height < 1) return;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      if (width === this._width && height === this._height && dpr === this._dpr) return;
      this._finishPointer(false);
      this._width = width;
      this._height = height;
      this._dpr = dpr;
      this._canvas.width = Math.round(width * dpr);
      this._canvas.height = Math.round(height * dpr);
      try {
        this._drawFoil();
        this._paths.forEach(path => this._drawPath(path));
        this.classList.add('is-ready');
        this._reward.setAttribute('aria-hidden', 'true');
        this._reward.inert = true;
        if (this._paths.length) this._scheduleCheck();
      } catch (_error) {
        this._reveal();
      }
    }

    _drawFoil() {
      const ctx = this._context;
      const w = this._width;
      const h = this._height;
      const style = getComputedStyle(this);
      const light = style.getPropertyValue('--kc-foil-light').trim() || '#f4f4f2';
      const mid = style.getPropertyValue('--kc-foil').trim() || '#c8c8c6';
      const dark = style.getPropertyValue('--kc-foil-dark').trim() || '#a3a3a1';
      ctx.setTransform(this._dpr, 0, 0, this._dpr, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
      const gradient = ctx.createLinearGradient(0, 0, w, h);
      gradient.addColorStop(0, mid);
      gradient.addColorStop(0.24, light);
      gradient.addColorStop(0.47, mid);
      gradient.addColorStop(0.65, light);
      gradient.addColorStop(1, dark);
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, w, h);
      ctx.fillStyle = 'rgba(255,255,255,0.2)';
      for (let y = 7; y < h; y += 14) {
        for (let x = 7 + (Math.round(y / 14) % 2) * 7; x < w; x += 14) {
          ctx.beginPath();
          ctx.arc(x, y, 0.8, 0, Math.PI * 2);
          ctx.fill();
        }
      }
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
    }

    _drawPath(path) {
      if (!path.points.length) return;
      const ctx = this._context;
      const radius = path.radius * Math.min(this._width, this._height);
      const first = path.points[0];
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fillStyle = '#000';
      ctx.strokeStyle = '#000';
      ctx.lineWidth = radius * 2;
      ctx.beginPath();
      ctx.arc(first[0] * this._width, first[1] * this._height, radius, 0, Math.PI * 2);
      ctx.fill();
      if (path.points.length > 1) {
        ctx.beginPath();
        ctx.moveTo(first[0] * this._width, first[1] * this._height);
        path.points.slice(1).forEach(point => ctx.lineTo(point[0] * this._width, point[1] * this._height));
        ctx.stroke();
      }
    }

    _point(event) {
      const rect = this._canvas.getBoundingClientRect();
      return [(event.clientX - rect.left) / rect.width, (event.clientY - rect.top) / rect.height];
    }

    _pointerDown(event) {
      if (this._revealed || !this.classList.contains('is-ready') || this._pointerId != null) return;
      if (event.isPrimary === false || (event.pointerType === 'mouse' && event.button !== 0)) return;
      event.preventDefault();
      this._pointerId = event.pointerId;
      this._activePath = {
        radius: this._brush / Math.min(this._width, this._height),
        points: [this._point(event)]
      };
      this._paths.push(this._activePath);
      this._setState('scratching');
      try {
        this._canvas.setPointerCapture(event.pointerId);
      } catch (_error) {  }
      try {
        this._drawPath(this._activePath);
        this._scheduleCheck();
      } catch (_error) {
        this._reveal();
      }
    }

    _pointerMove(event) {
      if (this._revealed || event.pointerId !== this._pointerId || !this._activePath) return;
      event.preventDefault();
      const events = typeof event.getCoalescedEvents === 'function' ? event.getCoalescedEvents() : [];
      const points = (events.length ? events : [event]).map(item => this._point(item));
      const previous = this._activePath.points[this._activePath.points.length - 1];
      this._activePath.points.push(...points);
      try {

        this._drawPath({ radius: this._activePath.radius, points: [previous, ...points] });
        this._scheduleCheck();
      } catch (_error) {
        this._reveal();
      }
    }

    _pointerEnd(event) {
      if (event.pointerId !== this._pointerId) return;
      this._finishPointer(true);
    }

    _finishPointer(check) {
      const pointerId = this._pointerId;
      this._pointerId = null;
      this._activePath = null;
      if (pointerId != null) {
        try {
          if (this._canvas?.hasPointerCapture(pointerId)) this._canvas.releasePointerCapture(pointerId);
        } catch (_error) {  }
      }
      if (check && !this._revealed) this._checkCoverage();
    }

    _scheduleCheck() {
      if (this._checkFrame || this._revealed) return;
      this._checkFrame = requestAnimationFrame(timestamp => {
        this._checkFrame = null;
        if (!this.isConnected || this._revealed) return;
        if (timestamp - (this._lastCheck || 0) < 90) {
          this._scheduleCheck();
          return;
        }
        this._lastCheck = timestamp;
        this._checkCoverage();
      });
    }

    _checkCoverage() {
      if (this._revealed || !this._context || !this._canvas.width || !this._canvas.height) return;
      try {
        const w = this._canvas.width;
        const h = this._canvas.height;
        const pixels = this._context.getImageData(0, 0, w, h).data;


        const step = Math.max(1, Math.floor(Math.sqrt((w * h) / 18000)));
        let cleared = 0;
        let sampled = 0;
        for (let y = Math.floor(step / 2); y < h; y += step) {
          for (let x = Math.floor(step / 2); x < w; x += step) {
            if (pixels[(y * w + x) * 4 + 3] < 128) cleared += 1;
            sampled += 1;
          }
        }
        if (sampled && (cleared / sampled) * 100 >= this._threshold) this._reveal();
      } catch (_error) {
        this._reveal();
      }
    }

    _setState(state) {
      const revealed = state === 'revealed';
      if (revealed) this.classList.add('is-ready');
      this.dataset.state = state;
      this._reward.setAttribute('aria-hidden', !revealed && this.classList.contains('is-ready') ? 'true' : 'false');
      this._reward.inert = !revealed && this.classList.contains('is-ready');
      if (this._label) this._label.hidden = state !== 'locked';
      this._buttons.forEach(button => { button.hidden = revealed; });
      this._links.forEach(link => { link.hidden = !revealed; });
      this._revealOnly.forEach(node => { node.hidden = !revealed; });
      this._statuses.forEach(node => {
        const text = revealed ? node.dataset.unlockedText : node.dataset.lockedText;
        if (text != null) node.textContent = text;
      });
    }

    _reveal() {
      if (this._revealed) return;
      const trigger = this._buttons.includes(document.activeElement) ? document.activeElement : null;
      const nextLink = trigger?.parentElement.querySelector('[data-offer-link]');
      this._revealed = true;
      clearInterval(this._countdownInterval);
      clearTimeout(this._attentionTimeout);
      this.classList.remove('is-attention');
      cancelAnimationFrame(this._checkFrame);
      this._checkFrame = null;
      this._finishPointer(false);
      this._setState('revealed');
      nextLink?.focus({ preventScroll: true });
      this._resizeObserver?.disconnect();
      if (this._canRemember()) {
        try { sessionStorage.setItem(this._storageKey(), '1'); } catch (_error) {  }
      }
      this.dispatchEvent(new CustomEvent('kc:scratch-revealed', {
        bubbles: true,
        detail: { sectionId: this.dataset.sectionId || '' }
      }));
    }

    _canRemember() {
      return this.dataset.remember === 'true'
        && this.dataset.preview !== 'true'
        && this.dataset.designMode !== 'true'
        && !window.Shopify?.designMode;
    }

    _storageKey() {
      return 'kc:scratch:v1:' + JSON.stringify([
        this.dataset.campaignId || this.dataset.sectionId || 'default',
        this.dataset.offerKey || '',
        this.dataset.countdownEnd || ''
      ]);
    }

    _wasRemembered() {
      if (!this._canRemember()) return false;
      try { return sessionStorage.getItem(this._storageKey()) === '1'; } catch (_error) { return false; }
    }
  }

  customElements.define('kidscraft-scratch-card', KidsCraftScratchCard);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kidscraft-early-access"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!customElements.get('kidscraft-early-access')) {
    class KidsCraftEarlyAccess extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected || this.eaController) return;
          this.eaController = new AbortController();
          const signal = this.eaController.signal;
          const form = this.querySelector('.ea-native-form');
          const button = form && form.querySelector('[data-ea-submit]');
          const label = button && button.querySelector('span');
          const original = label && label.textContent;
          if (form && button) {
            form.addEventListener('submit', event => {
              if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
              if (event.defaultPrevented) return;
              this.rememberLeadAttempt(form);
              button.disabled = true;
              label.textContent = this.dataset.submitting;
            }, { signal });
            window.addEventListener('pageshow', () => {
              button.disabled = false;
              label.textContent = original;
            }, { signal });
          }
          this.querySelectorAll('a[href^="#ea-anmeldung-"]').forEach(link => {
            link.addEventListener('click', () => {
              const email = this.querySelector('input[name="contact[email]"]');
              if (email) setTimeout(() => email.focus({ preventScroll: true }), 450);
            }, { signal });
          });
          this.publishSuccessfulLead(form);
          const result = this.querySelector('[data-ea-result]');
          if (result && !window.Shopify?.designMode) result.focus({ preventScroll: true });
        });
      }
     leadStorageKey(form) {
  return 'kidscraft:early-access:pending:' + this.dataset.eaCampaign + ':' + form.id;
}

rememberLeadAttempt(form) {
  if (window.Shopify?.designMode) return;
  try {
    const id = window.crypto?.randomUUID?.() ||
      Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);

    sessionStorage.setItem(this.leadStorageKey(form), JSON.stringify({
      id: 'kc-ea-' + id,
      createdAt: Date.now(),
      formId: form.id,
      campaign: this.dataset.eaCampaign,
      path: window.location.pathname,
      published: false
    }));
  } catch (_) {}
}

publishSuccessfulLead(form) {
  if (!form || window.Shopify?.designMode) return;
  const key = this.leadStorageKey(form);

  if (form.querySelector('[data-ea-error]')) {
    try { sessionStorage.removeItem(key); } catch (_) {}
    return;
  }

  if (!form.querySelector('[data-ea-success]')) return;

  let attempt;
  try {
    attempt = JSON.parse(sessionStorage.getItem(key));
  } catch (_) {
    return;
  }

  if (
    !attempt ||
    attempt.published ||
    attempt.formId !== form.id ||
    attempt.campaign !== this.dataset.eaCampaign ||
    attempt.path !== window.location.pathname
  ) return;

  const age = Date.now() - attempt.createdAt;
  if (!Number.isFinite(age) || age < 0 || age > 7200000) return;

  let retries = 0;

  const publish = async () => {
    if (!this.isConnected || this.eaLeadPublishing || attempt.published) return;

    const retry = () => {
      if (++retries < 120 && this.isConnected) {
        this.eaLeadTimer = setTimeout(publish, 250);
      }
    };

    if (typeof window.Shopify?.analytics?.publish !== 'function') {
      retry();
      return;
    }

    this.eaLeadPublishing = true;

    try {
      const accepted = await window.Shopify.analytics.publish(
        'kidscraft:early_access_signup',
        {
          event_id: attempt.id,
          form_id: form.id,
          campaign: attempt.campaign
        }
      );

      if (accepted === false) {
        retry();
        return;
      }

      attempt.published = true;
      try {
        sessionStorage.setItem(key, JSON.stringify(attempt));
      } catch (_) {}
    } catch (_) {
      retry();
    } finally {
      this.eaLeadPublishing = false;
    }
  };

  publish();
}

disconnectedCallback() {
  this.eaController?.abort();
  this.eaController = null;
  clearTimeout(this.eaLeadTimer);
}
    }
    customElements.define('kidscraft-early-access', KidsCraftEarlyAccess);
  }
})();
(() => {
function setupQuantityPills(root) {
  if (!root || root.dataset.kcPillsReady) return;

  const unitPrices = {
    
      
    
      
    
      
    
      
    
      
    
      
    
      
    
      
    
      
    
      
    
      
        
          '58448580542795': 4999,
        
      
    
      
        
          '58591647105355': 11995,
        
      
    
      
        
          '58591649956171': 9999,
        
      
    
      
    
      
    
      
    
      
    
      
    
      
    
      
    
      
    
      
    
      
    
      
    
      
    
      
    
      
    
      
    
      
    
      
    
      
    
      
    
  };

  const basisPrices = [4999, 7999, 9990];
  const basisVariantId = '58448580542795';
  const money = new Intl.NumberFormat('de-DE', {
    style: 'currency', currency: 'EUR'
  });

  queueMicrotask(() => {
    if (!root.isConnected || root.dataset.kcPillsReady) return;
    root.dataset.kcPillsReady = 'true';
    const cards = new Map();

    function refresh(card) {
      const state = cards.get(card);
      if (!state) return;
      const { form, button, quantity, pills, originalLabel } = state;
      const busy = form.getAttribute('aria-busy') === 'true';
      pills.disabled = busy || button.disabled;
      if (busy) return;

      const id = String(form.querySelector('[name="id"]').value);
      const unit = Number(unitPrices[id]);
      const count = Number(quantity.value);
      if (!Number.isFinite(unit) || ![1, 2, 3].includes(count)) return;

      const totals = id === basisVariantId
        ? basisPrices
        : [unit, Math.round(unit * 2 * 0.8), unit * 2];
      const price = money.format(totals[count - 1] / 100);
      const pricePattern = /(?:€\s*\d[\d.,]*|\d[\d.,]*\s*€)/g;
      button.dataset.label = /€/.test(originalLabel)
        ? originalLabel.replace(pricePattern, price)
        : originalLabel + ' – ' + price;
      if (!button.disabled) button.textContent = button.dataset.label;

      pills.querySelectorAll('input').forEach(input => {
        input.checked = Number(input.value) === count;
      });
    }

    root.querySelectorAll('[data-kc-offer]').forEach((card, index) => {
      if (index !== 0) return;
      const form = card.querySelector('.kc-form');
      const button = form && form.querySelector('[data-kc-buy]');
      const quantity = form && form.querySelector('input[type="hidden"][name="quantity"]');
      const variantInput = form && form.querySelector('[name="id"]');
      if (!button || !quantity || !variantInput || unitPrices[variantInput.value] == null) return;
      if (String(variantInput.value) !== basisVariantId) return;

      const pills = document.createElement('fieldset');
      pills.className = 'kc-qty-pills';
      pills.setAttribute('aria-label', root.dataset.qtyLabel);
      const labels = [root.dataset.qtyOne, root.dataset.qtyTwo, root.dataset.qtyThree];
      const badges = ['', root.dataset.qtyDiscount, root.dataset.qtyGift];
      const safeText = value => String(value || '').replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
      pills.innerHTML = labels.map((label, i) => `
        <label class="kc-qty-choice">
          <input class="kc-qty-radio" type="radio"
            name="kc-tier-${form.id || index}" value="${i + 1}">
          <span class="kc-qty-pill">${safeText(label)}</span>
          ${badges[i] ? `<span class="kc-qty-badge ${i === 2 ? 'kc-qty-badge--gift' : ''}">${safeText(badges[i])}</span>` : ''}
        </label>`).join('');

      cards.set(card, {
        form, button, quantity, pills,
        originalLabel: button.dataset.label || button.textContent.trim()
      });
      if (![1, 2, 3].includes(Number(quantity.value))) quantity.value = '1';
      button.before(pills);
      pills.addEventListener('change', event => {
        if (!root.kcPending && !button.disabled) quantity.value = event.target.value;
        refresh(card);
      });
      new MutationObserver(() => refresh(card)).observe(form, {
        attributes: true, attributeFilter: ['aria-busy']
      });
      refresh(card);
    });

    const originalUpdate = root.updateVariant;
    if (typeof originalUpdate === 'function') {
      root.updateVariant = function(card) {
        originalUpdate.call(this, card);
        refresh(card);
      };
    }
  });
}
if (customElements.get('kidscraft-early-products')) return;
  class KidsCraftEarlyProducts extends HTMLElement {
    connectedCallback() {
      if (this.kcConnected) return;
      this.kcConnected = true;
      this.kcAbort = new AbortController();
      this.kcRequests = new Set();
      this.kcBusy = new Set();
      this.kcPending = false;
      this.kcOfferVisible = false;
      this.kcHeroPassed = false;
      this.kcSubmit = this.handleSubmit.bind(this);
      this.kcChange = this.handleChange.bind(this);
      this.kcPageShow = this.handlePageShow.bind(this);
      this.kcBlockSelect = this.handleBlockSelect.bind(this);
      this.addEventListener('submit', this.kcSubmit, true);
      this.addEventListener('change', this.kcChange);
      window.addEventListener('pageshow', this.kcPageShow);
      document.addEventListener('shopify:block:select', this.kcBlockSelect);
      this.querySelectorAll('[data-kc-offer]').forEach(card => {
        const data = card.querySelector('[data-kc-variants]');
        try { card.kcVariants = data ? JSON.parse(data.textContent) : []; }
        catch (_) { card.kcVariants = []; }
        this.updateVariant(card);
      });
      setupQuantityPills(this);
      this.kcSticky = this.querySelector('[data-kc-sticky]');
      if (this.kcSticky && 'IntersectionObserver' in window) {
        this.kcObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target.hasAttribute('data-kc-offers')) this.kcOfferVisible = entry.isIntersecting;
            else this.kcHeroPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          });
          this.kcSticky.classList.toggle('kc-show', this.kcHeroPassed && !this.kcOfferVisible);
        });
        const hero = this.querySelector('[data-kc-hero-cta]') || this.querySelector('.kc-hero') || this.querySelector('section');
        const offers = this.querySelector('[data-kc-offers]');
        if (hero) this.kcObserver.observe(hero);
        if (offers) this.kcObserver.observe(offers);
      }
    }
    disconnectedCallback() {
      this.kcConnected = false;
      this.removeEventListener('submit', this.kcSubmit, true);
      this.removeEventListener('change', this.kcChange);
      window.removeEventListener('pageshow', this.kcPageShow);
      document.removeEventListener('shopify:block:select', this.kcBlockSelect);
      if (this.kcObserver) this.kcObserver.disconnect();
      if (this.kcRequests) this.kcRequests.forEach(controller => controller.abort());
      if (this.kcAbort) this.kcAbort.abort();
    }
    handleBlockSelect(event) {
      const block = event.target;
      if (!(block instanceof Element) || !this.contains(block)) return;
      if (block.tagName === 'DETAILS') block.open = true;
      block.scrollIntoView({ block: 'center', behavior: 'auto' });
    }
    handlePageShow() {
      if (!this.kcBusy) return;
      this.kcBusy.clear();
      this.kcPending = false;
      this.querySelectorAll('.kc-form').forEach(form => {
        form.removeAttribute('aria-busy');
        const selector = form.querySelector('[data-kc-variant]');
        if (selector) selector.disabled = false;
        this.updateVariant(form.closest('[data-kc-offer]'));
      });
    }
    handleChange(event) {
      if (!event.target.matches('[data-kc-variant]')) return;
      this.updateVariant(event.target.closest('[data-kc-offer]'));
    }
    updateVariant(card) {
      if (!card) return;
      const form = card.querySelector('.kc-form');
      if (!form || (this.kcBusy && this.kcBusy.has(form))) return;
      const input = form.querySelector('[name="id"]');
      const variant = (card.kcVariants || []).find(item => String(item.id) === String(input && input.value));
      const button = form.querySelector('[data-kc-buy]');
      if (!button) return;
      const available = !!(variant && variant.available && card.dataset.unavailableProduct !== 'true');
      button.disabled = !available;
      button.textContent = available ? button.dataset.label : this.dataset.unavailable;
      const price = card.querySelector('[data-kc-price]');
      const compare = card.querySelector('[data-kc-compare]');
      if (variant && price) price.textContent = variant.price;
      if (compare) {
        compare.hidden = !(variant && variant.compare);
        compare.textContent = variant && variant.compare ? variant.compare : '';
      }
      const error = form.querySelector('[data-kc-error]');
      if (error) { error.hidden = true; error.textContent = ''; }
    }
    async handleSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.classList.contains('kc-form') || !this.contains(form)) return;
      event.preventDefault();
      event.stopPropagation();
      if (this.kcPending || this.kcBusy.has(form)) return;
      const button = form.querySelector('[data-kc-buy]');
      const card = form.closest('[data-kc-offer]');
      if (!button || button.disabled) return;
      const error = form.querySelector('[data-kc-error]');
      const variantInput = form.querySelector('[name="id"]');
      const variantId = variantInput && variantInput.value;
      const quantity = Number(form.querySelector('[name="quantity"]').value || 1);
      const variant = (card.kcVariants || []).find(item => String(item.id) === String(variantId));
      if (!variant || !variant.available || !/^\d+$/.test(String(variantId)) || !Number.isInteger(quantity) || quantity < 1) return;
      if (error) { error.hidden = true; error.textContent = ''; }
      this.kcBusy.add(form);
      this.kcPending = true;
      form.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.textContent = this.dataset.loading;
      const selector = form.querySelector('[data-kc-variant]');
      if (selector) selector.disabled = true;
      const controller = new AbortController();
      this.kcRequests.add(controller);
      let redirecting = false;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
          signal: controller.signal
        });
        let payload;
        try { payload = await response.json(); } catch (_) { payload = null; }
        if (!response.ok) {
          const detail = payload && (payload.description || payload.message);
          const failure = new Error(typeof detail === 'string' ? detail : this.dataset.error);
          throw failure;
        }
        window.location.assign(this.dataset.checkoutUrl);
        redirecting = true;
      } catch (failure) {
        if (failure.name === 'AbortError') return;
        if (error && this.isConnected) {
          error.textContent = failure instanceof TypeError ? this.dataset.error : (failure.message || this.dataset.error);
          error.hidden = false;
        }
      } finally {
        this.kcRequests.delete(controller);
        if (!redirecting) {
          this.kcBusy.delete(form);
          this.kcPending = false;
          form.removeAttribute('aria-busy');
          if (selector) selector.disabled = false;
          if (this.isConnected) {
            button.disabled = false;
            button.textContent = button.dataset.label;
          }
        }
      }
    }
  }
  customElements.define('kidscraft-early-products', KidsCraftEarlyProducts);

})();

  } catch(e) { console.error(e); }
})();
})();
